var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.49943 10L2.51 3L23.4993 12.0017L2.50852 21L2.4991 14L17.4993 12.0012L2.49943 10ZM4.50975 6.03016L12.0195 9.25078L4.49957 8.25016L4.50975 6.03016ZM12.009 14.7508L4.49877 17.9702L4.49895 15.7502L12.009 14.7508Z",
    fill: "#003366"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend24Px);
export default __webpack_public_path__ + "static/media/send_24px.a042a5307747e6d3c972ef5abc07f60c.svg";
export { ForwardRef as ReactComponent };